import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function GreaterPoland() {
  return (
    <>
      <DisplayMaster voivodeship="GreaterPoland" />
    </>
  );
}